































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator';
import { Dictionary } from 'lodash';
import { SerializedShortAnswer } from '@xlearn/common';
import * as Api from "@/app/question/components/api";
import { ShortAnswerAnswer } from './short-answer-interfaces';
import { TranslateResult } from 'vue-i18n';
import i18n from '@/plugins/i18n';

interface ShortQuestion {
  id: number;
  questionId: string;
  title: string;
}

@Component({
  components: { }
})
export default class ShortAnswerQuestionComponent extends Vue
implements Api.QuestionComponent<SerializedShortAnswer, ShortAnswerAnswer, {}> {
  @Prop({
    required: true,
  })
  public question: Api.Question<SerializedShortAnswer>;

  @Prop({
    required: true,
  })
  public evaluated: boolean;

  @Prop({
    required: true,
  })
  public showSolution: boolean;

  @Prop({
    required: true,
  })
  public answer: Api.Answer<ShortAnswerAnswer> | null;

  @Prop({
    required: true,
  })
  public state: null;

  private questions: ShortQuestion[] = this.mapQuestions();

  private answersState: Dictionary<string> = this.initialAnswersState();

  @Watch('answer')
  private answerChanged(newValue: Api.Answer<ShortAnswerAnswer> | null): void {
    if (!this.answer) {
      this.answersState = this.initialAnswersState();
    }
  }

  @Emit('state-changed')
  public emitStateChanged(): Api.StateChangedPayload<{}> {
    return {
      state: {}
    };
  }

  @Emit('answer-changed')
  public emitAnswerChanged(): Api.AnswerChangedPayload<ShortAnswerAnswer> {
    let finished: boolean = true;
    let score: number = 0;

    for (const [questionId, answer] of Object.entries(this.answersState)) {
      const question = this.question.content.questions.find((q) => q.id === questionId);
      let questionScore = 0;
      let isCorrect = false;

      if (!question) {
        continue;
      }

      const answerLower: string = answer.toLowerCase().trim();
      const answered: boolean = answerLower !== '';
      if (!answered) {
        finished = false;
      } else {
        question.answers.forEach((a) => {
          if (a.answer.toLowerCase() === answerLower) {
            questionScore = a.score;
            isCorrect = true;
          }
        });
      }

      if (answerLower && !isCorrect) {
        questionScore = question.incorrectScore;
      }

      score += questionScore;
    }

    return {
      answer: {
        userAnswers: this.answersState,
      },
      score,
    };
  }

  private isAnswerCorrect(questionId: string): boolean {
    const answer: string = this.answersState[questionId];
    const question = this.question.content.questions.find((q) => q.id === questionId);
    if (!question) {
      return false;
    }

    const answerLower: string = answer.toLowerCase().trim();
    const answered: boolean = answerLower !== '';
    if (!answered) {
      return false;
    }

    for (const a of question.answers) {
      if (a.answer.toLowerCase() === answerLower) {
        return true;
      }
    }

    return false;
  }

  private correctAnswers(questionId: string): string {
    const question = this.question.content.questions.find((q) => q.id === questionId);
    if (!question) {
      return '';
    }

    let answers: string[] = [];
    question.answers.forEach((a) => answers = [...answers, a.answer]);

    return answers.join(', ');
  }

  private mapQuestions(): ShortQuestion[] {
    let questions: ShortQuestion[] = [];
    let index: number = 1;
    this.question.content.questions.forEach((question) => {
      questions = [...questions, {
        id: index,
        questionId: question.id,
        title: question.question
      }];

      index++;
    });

    return questions;
  }

  private initialAnswersState(): Dictionary<string> {
    if (this.evaluated && this.answer) {
      return this.answer.answer.userAnswers;
    }

    const state: Dictionary<string> = {};
    this.question.content.questions.forEach((answer) =>
      state[answer.id] = this.answer
      ? this.answer.answer.userAnswers[answer.id]
      : ''
    );

    return state;
  }

  private t(key: string, params: any = {}): TranslateResult {
    return i18n.t(key, params);
  }
}
